import { useEffect, useState } from 'react'
import getCollection from '../../utils/db/getCollection'

const useBrandsById = () => {
  const [brandsById, setBrandsById] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let isMounted = true

    getCollection({ path: 'brands', docIdName: 'id' })
      .then((brands) => {
        if (!isMounted) {
          return
        }

        const nextMap = brands.reduce((acc, brand) => {
          const name = brand.name?.trim()
          if (name) {
            acc[brand.id] = name
          }
          return acc
        }, {})

        setBrandsById(nextMap)
      })
      .catch((error) => {
        console.error('[useBrandsById] failed:', error)
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return {
    brandsById,
    isLoading,
  }
}

export default useBrandsById
